import { FormStore } from '@roc/feature-app-core';
import {
  createCurrencyField,
} from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const PurchasePrice = observer(({ label, store }: { label: string, store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label,
        fieldName: 'acquisitionPrice',
        testId: 'acquisitionPrice',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});